import { ConversationView } from '@/features/inbox/ConversationView';
import { createFileRoute } from '@tanstack/react-router';

// The nav highlight (inbox) comes from the /inbox parent route.
export const Route = createFileRoute('/inbox/$conversationId')({
  component: ConversationView,
});
